<template>
    <div id="articelDetail" class="KbDetailLtContainer__articelDetail">
        <div class="KbDetailLtContainer__articleTitle">
            <h1 data-id="article_Title" class="KbDetailLtContainer__detailHeader commonStyle__detailHeader">CM evolveIT For IBM® Enterprise Systems</h1></div><!-- react-empty: 1267 --><div class="KbDetailLtContainer__articleContent commonStyle__positionRel commonStyle__wordWrapWord commonStyle__wordBreakWord" id="article_TOC"><p class="description"><p class="MsoNormal" style="text-align: center" align="center"><b style=""><span style="font-size: 14pt; line-height: 107%">Providing Source Code for
Initial CM evolveIT Discovery</span></b></p>

<p class="MsoNormal"><span style="">When
providing your Cobol system assets to us for discovery and creation of your
initial CM evolveIT repository, please consider the following:</span></p>

<p class="MsoNormal"><span style="">&nbsp;</span></p>

<p class="MsoNormal"><b style=""><span style="">Format</span></b></p>

<p class="MsoNormal"><span style="">Source
code should be provided as individual source files in standard Windows 7-bit
ASCII text format zip’ed as a Microsoft Windows directory.<span style="">&nbsp; </span>Please note that when using FTP from the
mainframe where an EBCDIC to ASCII conversion is performed, take care that no
characters are translated into Control Z.</span></p>

<p class="MsoNormal"><b style=""><span style="">Source</span></b></p>

<p class="MsoNormal"><span style="">Please
supply source for all of the following that are assets of your system.<span style="">&nbsp; </span>If you are not aware of the full interaction
set, we can complete the discovery and then tell you what source code is missing.<span style="">&nbsp; </span>(Keep in mind that CM evolveIT will identify
missing assets by finding unresolved references in the source code assets
provided.<span style="">&nbsp; </span>It is possible that each new
set of source code provided may contain references to additional missing source
code assets.)</span></p>

<p class="MsoNormal"><span style="">&nbsp;</span></p>

<ul style="margin-top: 0in">
 <li class="MsoNormal" style=""><span style="">COBOL Program Source</span></li>
 <li class="MsoNormal" style=""><span style="">COBOL Copybook Source,
     Dclgen Copybooks</span></li>
 <li class="MsoNormal" style=""><span style="">Schema Source – DB2
     DDL</span></li>
 <li class="MsoNormal" style=""><span style="">Mapsets (i.e. BMS)</span></li>
 <li class="MsoNormal" style=""><span style="">JCL Source</span></li>
 <li class="MsoNormal" style=""><span style="">JCL Procs</span></li>
 <li class="MsoNormal" style=""><span style="">Parm Cards</span></li>
 <li class="MsoNormal" style=""><span style="">CICS</span></li>
 <ul style="margin-top: 0in">
  <li class="MsoNormal" style=""><span style="">CSD extract using IBM
      standard program DFHCSDUP</span><span style="font-size: 11pt; line-height: 107%"></span></li>
  <li class="MsoNormal" style=""><span style="">Supply parms to
      DFHCSDUP, then use subroutines from IBM (DFH$FORA) to put the format into
      one-line output.&nbsp; The JCL needed to do this is below.</span><span style="font-size: 11pt; line-height: 107%"></span></li>
  <li class="MsoNormal" style=""><span style="">The file sent to CM
      evolveIT will be limited to certain records, as the CICS file alone can
      have duplicates.&nbsp;</span></li>
 </ul>
</ul>

<p class="MsoNormal" style="margin-left: 0.75in"><span style="">Explanation of this can be found in the CICS/TS 4.2
manual Resource Definition Guide at IBM.COM</span></p>

<p class="MsoNormal" style="margin-left: 0.75in"><span style="">A summary explanation of the
record layout in this file appears in “CICS File Extract format” below.</span></p>

<p class="MsoNormal" style="margin-left: 0.75in"><span style="">Special note* The output dataset must have these
attributes.</span></p>

<p class="MsoNormal" style="margin-left: 0.75in"><span style="">Organization&nbsp; . . . : PS&nbsp; </span></p>

<p class="MsoNormal" style="margin-left: 0.75in"><span style="">Record format . . . : F&nbsp;&nbsp; </span></p>

<p class="MsoNormal" style="margin-left: 0.75in"><span style="">Record length . . . : 1536</span></p>

<p class="MsoNormal" style="margin-left: 0.75in"><span style="">Block size&nbsp; . . . . : 1536</span></p>

<p class="MsoNormal" style="margin-left: 0.75in"><span style="">&nbsp;</span></p>

<p class="MsoNormal" style="margin-left: 0.75in"><span style="">CICS Resources</span></p>

<p class="MsoNormal" style="margin-left: 0.75in"><span style="">How to limit the number of resources that need to be
extracted.</span></p>

<p class="MsoNormal" style="margin-left: 0.75in"><span style="">&nbsp;</span></p>

<p class="MsoNormal" style="margin-left: 0.75in"><span style="">GRPLIST is a CICS system initialization parameter that
will contain up to four “lists” of groups that contain the resources that we
may need to look at.<span style="">&nbsp; </span>We only want to
extract the resources from the groups that are used by the application.</span></p>

<p class="MsoNormal" style="margin-left: 0.75in"><span style="">&nbsp;</span></p>

<p class="MsoNormal" style="margin-left: 0.75in"><span style="">The resources that we are interested in are:<span style="">&nbsp; </span>programs, files (FCT), queues (TDQ),
transactions (PCT), and mapsets.<span style="">&nbsp; </span>We can
include an input dataset pointed to by the CRFINPT DD that will control which
resources are extracted.<span style="">&nbsp; </span>CRFINPT is a
sequential file containing 80-byte records. Each record contains one object or
keyword to be cross-referenced. The CRFINPT file should contain the following
entries (one per line):</span></p>

<p class="MsoNormal" style="margin-left: 0.75in"><span style="">&nbsp;</span></p>

<p class="MsoNormal" style="margin-left: 0.75in; background: white"><span style="color: black">PROGRAM</span></p>

<p class="MsoNormal" style="margin-left: 0.75in; background: white"><span style="color: black">TRANSACTION</span></p>

<p class="MsoNormal" style="margin-left: 0.75in; background: white"><span style="color: black">FILE</span></p>

<p class="MsoNormal" style="margin-left: 0.75in; background: white"><span style="color: black">TDQ</span></p>

<p class="MsoNormal" style="margin-left: 0.75in; background: white"><span style="color: black">MAPSET</span><span style=""></span></p>

<p class="MsoNormal" style="margin-left: 0.75in; background: white"><span style="">&nbsp;</span></p>

<p class="MsoNormal"><span style="">The
JCL sample below can be used to extract the data once you have narrowed down
the groups you want to use. </span></p>

<p class="MsoNormal"><span>&nbsp;</span></p>

<p class="MsoNormal" style="background: white"><span style="color: black">//JOBCARD<span style="">&nbsp;
</span>JOB MSGCLASS=H,CLASS=A,NOTIFY=&amp;SYSUID<span style="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></p>

<p class="MsoNormal" style="background: white"><span style="color: black">//*-----------------------------------------------</span></p>

<p class="MsoNormal" style="background: white"><span style="color: black">//*CSD EXTRACT<span style="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span style="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span></p>

<p class="MsoNormal" style="background: white"><span style="color: black">//*-----------------------------------------------</span></p>

<p class="MsoNormal" style="background: white"><span style="color: black">//EXTRACT<span style="">&nbsp;
</span>EXEC PGM=DFHCSDUP,</span></p>

<p class="MsoNormal" style="background: white"><span style="color: black">//<span style="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>PARM=’CSD(READONLY)’<span style="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></p>

<p class="MsoNormal" style="background: white"><span style="color: black">//SYSPRINT DD SYSOUT=*<span style="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></p>

<p class="MsoNormal" style="background: white"><span style="color: black">//CDBOUT&nbsp;&nbsp; DD
SYSOUT=*&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="color: rgb(34, 34, 34)"></span></p>

<p class="MsoNormal" style="background: white"><span style="color: black">//CRFOUT&nbsp;&nbsp; DD
SYSOUT=*&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style="color: rgb(34, 34, 34)"></span></p>

<p class="MsoNormal" style="background: white"><span style="color: black">//CRFINPT&nbsp; DD DSN=&lt;your input
dataset&gt;,DISP=SHR</span><span style="color: rgb(34, 34, 34)"></span></p>

<p class="MsoNormal" style="background: white"><span style="color: black">//*<span style="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></p>

<p class="MsoNormal" style="background: white"><span style="color: black">//STEPLIB<span style="">&nbsp;
</span>DD DSN=&lt;cicshlq&gt;.<span style="background: yellow">SDFHLOAD</span>,DISP=SHR <span style="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span></p>

<p class="MsoNormal" style="background: white"><span style="color: black">//DFHCSD<span style="">&nbsp;&nbsp;
</span>DD DSN=&lt;your CSD dataset&gt;,DISP=SHR<span style="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></p>

<p class="MsoNormal" style="background: white"><span style="color: black">//SYSOUT<span style="">&nbsp;&nbsp;
</span>DD *<span style="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></p>

<p class="MsoNormal" style="background: white"><span style="color: black">//<span style="background: yellow">FOROUT</span><span style="">&nbsp;&nbsp; </span>DD DSN=&lt;your
output dataset&gt;,DISP=SHR<span style="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></p>

<p class="MsoNormal" style="background: white"><span style="color: black">//SYSIN<span style="">&nbsp;&nbsp;&nbsp;
</span>DD *<span style="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span><span style="">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span></p>

<p class="MsoNormal" style="background: white"><span style="color: black"><span style="">&nbsp; </span>EXTRACT
GROUP(program group) USERPROGRAM(<span style="background: yellow">DFH0FORC</span>) OBJECTS</span></p>

<p class="MsoNormal" style="background: white"><span style="color: black"><span style="">&nbsp; </span>EXTRACT
GROUP(FCT group) USERPROGRAM(<span style="background: yellow">DFH0FORC</span>)
OBJECTS</span></p>

<p class="MsoNormal" style="background: white"><span style="color: black"><span style="">&nbsp; </span>EXTRACT
GROUP(TDQ group) USERPROGRAM(<span style="background: yellow">DFH0FORC</span>)
OBJECTS</span></p>

<p class="MsoNormal" style="background: white"><span style="color: black"><span style="">&nbsp; </span>EXTRACT
GROUP(PCT group) USERPROGRAM(<span style="background: yellow">DFH0FORC</span>)
OBJECTS</span></p>

<p class="MsoNormal" style="background: white"><span style="color: black"><span style="">&nbsp; </span>EXTRACT
GROUP(mapset group) USERPROGRAM(<span style="background: yellow">DFH0FORC</span>) OBJECTS</span></p>

<p class="MsoNormal" style="background: white"><span style="color: black">/*</span></p>

<p class="MsoNormal" style="background: white"><span style="color: black">//</span></p>

<p class="MsoNormal" style="margin-left: 0.75in; background: white"><span style="color: rgb(34, 34, 34)">&nbsp;</span><span style="color: black">NOTES:<span style="">&nbsp; </span></span><span></span></p>

<p class="MsoListParagraph" style="margin-left: 1.25in; text-indent: -0.25in"><b style=""><span><span style="">1.<span style="font: 7pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp; </span></span></span></b><b style=""><span>The FOROUT dataset must
have a record size of 1536</span></b></p>

<p class="MsoNormal"><span>&nbsp;</span></p>

<p class="MsoListParagraph" style="margin-left: 1.25in; text-indent: -0.25in"><b style=""><span><span style="">2.<span style="font: 7pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp; </span></span></span></b><b style=""><span>The USERPROGRAM can be
DFH$FORA for assembler, DFH0FORC for COBOL, and DFH$FORP for PL/I.</span></b></p>

<p class="MsoListParagraph" style="margin-top: 0in; margin-right: 0in; margin-bottom: 0in; margin-left: 1.25in; text-indent: -0.25in"><b style=""><span><span style="">3.<span style="font: 7pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp; </span></span></span></b><b style=""><span>The EXTRACT statement can
also use LIST(listname) to get all of the groups in the list</span></b></p>

<p class="MsoListParagraph" style="margin-top: 0in; margin-right: 0in; margin-bottom: 0in; margin-left: 1.25in; text-indent: -0.25in"><b style=""><span><span style="">4.<span style="font: 7pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp; </span></span></span></b><b style=""><span>The CRFINPT dataset DCB
parameters must be DSORG=PS, RECFM=F, LRECL=80, and BLKSIZE=80.</span></b></p>

<p class="MsoNormal"><span>&nbsp;</span></p>

<p class="MsoNormal"><b style=""><span style="">Structure</span></b></p>

<p class="MsoNormal"><span style="">Please
divide the files into named directories for each of the file types described
above and zip each group at the directory level.<span style="">&nbsp; </span><span style="">&nbsp;</span>If you
have multiple source sets of any component type, please provide a separate
directory for each set.<span style="">&nbsp; </span>(Copybook1,
Copybook2)</span></p>

<p class="MsoNormal"><b style=""><span style="">Other Information</span></b></p>

<p class="MsoNormal"><span style="">Please
write a few words as a TXT or DOC that explain the directory structure that you
are providing.</span></p>

<p class="MsoNormal"><b style=""><span style="">Transfer</span></b></p>

<p class="MsoNormal"><span style="">We
can accept ZIP files up to 10MB.<span style="">&nbsp; </span>If
however, you have larger sets of source code assets, we can supply an FTP
location where you can upload your source code.<span style="">&nbsp;
</span>(For security reasons we suggest that most customers use our FTP option.</span></p>

<p class="MsoNormal" style="margin-left: 0.5in"><b><u><span style="">Commands for FTP of multiple members from a PDS:</span></u></b><span style=""> <br>
&nbsp;</span><span style=""><br>
To transfer multiple members of a PDS and assign the member name as the
filename on the target server directory, the following FTP control commands are
required.</span><span style=""> <br>
&nbsp;</span><b><span style=""><br>
CD:</span></b><span style=""> &nbsp;Change directory command to set the target
server directory name for the transfer.</span><span style=""> </span><b><span style=""><br>
Syntax:</span></b><span style=""> &nbsp;CD \your\target\directory\name<b><br>
LCD:</b> &nbsp;Local Change Directory command to identify the PDS name for mass
transfer.</span><span style=""> </span><b><span style=""><br>
Syntax:</span></b><span style=""> &nbsp;LCD YOUR.PDS.NAME<b><br>
MPUT:</b> &nbsp;Multiple Put command to specify mass transfer of members in the
PDS. &nbsp;(Asterisk denotes transfer of all members in the PDS.)</span><span style=""> </span><b><span style=""><br>
Syntax:</span></b><span style=""> &nbsp;MPUT (*)</span><span style=""> <br style="">
<br style="">
</span><span style="color: black"></span></p>

<p class="MsoNormal" style="margin-left: 1in"><span style="color: black">Example:
</span></p>

<p class="MsoNormal" style="margin-left: 1in"><span style="color: black">CD
\Your\Target\Directory</span></p>

<p class="MsoNormal" style="margin-left: 1in"><span style="color: black">LCD
YOUR.PDS.NAME</span></p>

<p class="MsoNormal" style="margin-left: 1in"><span style="color: black">MPUT
(*) </span></p>

<p class="MsoNormal" style="margin-left: 1in"><span style="color: black">&nbsp;</span></p>

<p class="MsoNormal" style="margin-left: 1in"><span style="color: black">This
will transfer each member of the PDS to the server as individual text files. </span></p>

<p class="MsoNormal"><span style="">&nbsp;</span></p>

<p class="MsoNormal"><b style=""><span style="">CICS File
Extract format</span></b></p>

<p class="MsoNormal"><span style="">The file extracted from CICS using the instructions
above is expected to contain records formatted according to the following
rules:</span></p>

<p class="MsoHeader"><b><span style="">Record
Type</span></b></p>

<p class="MsoNormal"><span style="">The first 4 characters of each line define the CICS
item type defined on the line. This in turn defines the format of the line
(defined in the following tables)</span></p>

<p class="MsoNormal"><span style="">&nbsp;</span></p>

<div align="center">

<table class="MsoTableGrid" style="border-collapse: collapse; border: none" width="341" cellspacing="0" cellpadding="0" border="1">
 <tbody><tr style="height: 17.55pt">
  <td style="width: 128pt; border: solid windowtext 1pt; padding: 0in 5.4pt 0in 5.4pt; height: 17.55pt" width="171" valign="top">
  <p class="MsoNormal" style="text-align: justify"><b><span style="font-size: 10.5pt; line-height: 107%">Column 1-4
  value</span></b></p>
  </td>
  <td style="width: 128pt; border: solid windowtext 1pt; border-left: none; padding: 0in 5.4pt 0in 5.4pt; height: 17.55pt" width="171" valign="top">
  <p class="MsoNormal" style="text-align: justify"><b><span style="font-size: 10.5pt; line-height: 107%">Type of
  CICS item</span></b></p>
  </td>
 </tr>
 <tr style="height: 17.55pt">
  <td style="width: 128pt; border: solid windowtext 1pt; border-top: none; padding: 0in 5.4pt 0in 5.4pt; height: 17.55pt" width="171" valign="top">
  <p class="MsoNormal" style="text-align: justify"><span style="font-size: 10.5pt; line-height: 107%">FILE</span></p>
  </td>
  <td style="width: 128pt; border-top: none; border-left: none; border-bottom: solid windowtext 1pt; border-right: solid windowtext 1pt; padding: 0in 5.4pt 0in 5.4pt; height: 17.55pt" width="171" valign="top">
  <p class="MsoNormal" style="text-align: justify"><span style="font-size: 10.5pt; line-height: 107%">File</span></p>
  </td>
 </tr>
 <tr style="height: 17.55pt">
  <td style="width: 128pt; border: solid windowtext 1pt; border-top: none; padding: 0in 5.4pt 0in 5.4pt; height: 17.55pt" width="171" valign="top">
  <p class="MsoNormal" style="text-align: justify"><span style="font-size: 10.5pt; line-height: 107%">MAPS</span></p>
  </td>
  <td style="width: 128pt; border-top: none; border-left: none; border-bottom: solid windowtext 1pt; border-right: solid windowtext 1pt; padding: 0in 5.4pt 0in 5.4pt; height: 17.55pt" width="171" valign="top">
  <p class="MsoNormal" style="text-align: justify"><span style="font-size: 10.5pt; line-height: 107%">Mapset</span></p>
  </td>
 </tr>
 <tr style="height: 18.15pt">
  <td style="width: 128pt; border: solid windowtext 1pt; border-top: none; padding: 0in 5.4pt 0in 5.4pt; height: 18.15pt" width="171" valign="top">
  <p class="MsoNormal" style="text-align: justify"><span style="font-size: 10.5pt; line-height: 107%">PROG</span></p>
  </td>
  <td style="width: 128pt; border-top: none; border-left: none; border-bottom: solid windowtext 1pt; border-right: solid windowtext 1pt; padding: 0in 5.4pt 0in 5.4pt; height: 18.15pt" width="171" valign="top">
  <p class="MsoNormal" style="text-align: justify"><span style="font-size: 10.5pt; line-height: 107%">Program</span></p>
  </td>
 </tr>
 <tr style="height: 18.15pt">
  <td style="width: 128pt; border: solid windowtext 1pt; border-top: none; padding: 0in 5.4pt 0in 5.4pt; height: 18.15pt" width="171" valign="top">
  <p class="MsoNormal" style="text-align: justify"><span style="font-size: 10.5pt; line-height: 107%">TDQU</span></p>
  </td>
  <td style="width: 128pt; border-top: none; border-left: none; border-bottom: solid windowtext 1pt; border-right: solid windowtext 1pt; padding: 0in 5.4pt 0in 5.4pt; height: 18.15pt" width="171" valign="top">
  <p class="MsoNormal" style="text-align: justify"><span style="font-size: 10.5pt; line-height: 107%">CICS Queue</span></p>
  </td>
 </tr>
 <tr style="height: 18.15pt">
  <td style="width: 128pt; border: solid windowtext 1pt; border-top: none; padding: 0in 5.4pt 0in 5.4pt; height: 18.15pt" width="171" valign="top">
  <p class="MsoNormal" style="text-align: justify"><span style="font-size: 10.5pt; line-height: 107%">TRAN</span></p>
  </td>
  <td style="width: 128pt; border-top: none; border-left: none; border-bottom: solid windowtext 1pt; border-right: solid windowtext 1pt; padding: 0in 5.4pt 0in 5.4pt; height: 18.15pt" width="171" valign="top">
  <p class="MsoNormal" style="text-align: justify"><span style="font-size: 10.5pt; line-height: 107%">CICS
  Transaction</span></p>
  </td>
 </tr>
</tbody></table>

</div>

<p class="MsoNormal" style="text-align: center" align="center"><span style="">&nbsp;</span></p>

<p class="MsoHeader"><b><span style="">File
Items</span></b></p>

<div align="center">

<table class="MsoNormalTable" style="border-collapse: collapse" width="303" cellspacing="0" cellpadding="0" border="0">
 <tbody><tr style="height: 11.35pt">
  <td style="width: 61.25pt; background: black; padding: 0.75pt 0.75pt 0.75pt 0.75pt; height: 11.35pt" width="82" valign="bottom">
  <p class="MsoNormal"><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">&nbsp;</span></b></p>
  </td>
  <td style="width: 53.95pt; background: black; padding: 0.75pt 0.75pt 0.75pt 0.75pt; height: 11.35pt" width="72" valign="bottom">
  <p class="MsoNormal" style="vertical-align: bottom"><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">Field Start</span></b><b style=""><span style="font-size: 11pt; line-height: 107%; color: white"></span></b></p>
  </td>
  <td style="width: 48.6pt; background: black; padding: 0.75pt 0.75pt 0.75pt 0.75pt; height: 11.35pt" width="65" valign="bottom">
  <p class="MsoNormal" style="vertical-align: bottom"><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">Field End</span></b><b style=""><span style="font-size: 11pt; line-height: 107%; color: white"></span></b></p>
  </td>
  <td style="width: 63.65pt; background: black; padding: 0.75pt 0.75pt 0.75pt 0.75pt; height: 11.35pt" width="85" valign="bottom">
  <p class="MsoNormal" style="vertical-align: bottom"><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">Field Length</span></b><b style=""><span style="font-size: 11pt; line-height: 107%; color: white"></span></b></p>
  </td>
 </tr>
 <tr style="height: 11.35pt">
  <td style="width: 61.25pt; background: black; padding: 0.75pt 0.75pt 0.75pt 0.75pt; height: 11.35pt" width="82" valign="bottom">
  <p class="MsoNormal" style="vertical-align: bottom"><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">Type</span></b><b style=""><span style="font-size: 11pt; line-height: 107%; color: white"></span></b></p>
  </td>
  <td style="width: 53.95pt; padding: 0.75pt 0.75pt 0.75pt 0.75pt; height: 11.35pt" width="72" valign="bottom">
  <p class="MsoNormal" style="vertical-align: bottom"><span style="font-size: 11pt; line-height: 107%; color: black">1</span><span style="font-size: 11pt; line-height: 107%; color: black"></span></p>
  </td>
  <td style="width: 48.6pt; padding: 0.75pt 0.75pt 0.75pt 0.75pt; height: 11.35pt" width="65" valign="bottom">
  <p class="MsoNormal" style="vertical-align: bottom"><span style="font-size: 11pt; line-height: 107%; color: black">4</span><span style="font-size: 11pt; line-height: 107%; color: black"></span></p>
  </td>
  <td style="width: 63.65pt; padding: 0.75pt 0.75pt 0.75pt 0.75pt; height: 11.35pt" width="85" valign="bottom">
  <p class="MsoNormal" style="vertical-align: bottom"><span style="font-size: 11pt; line-height: 107%; color: black">4</span><span style="font-size: 11pt; line-height: 107%; color: black"></span></p>
  </td>
 </tr>
 <tr style="height: 11.35pt">
  <td style="width: 61.25pt; background: black; padding: 0.75pt 0.75pt 0.75pt 0.75pt; height: 11.35pt" width="82" valign="bottom">
  <p class="MsoNormal" style="vertical-align: bottom"><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">File Name1</span></b><b style=""><span style="font-size: 11pt; line-height: 107%; color: white"></span></b></p>
  </td>
  <td style="width: 53.95pt; padding: 0.75pt 0.75pt 0.75pt 0.75pt; height: 11.35pt" width="72" valign="bottom">
  <p class="MsoNormal" style="vertical-align: bottom"><span style="font-size: 11pt; line-height: 107%; color: black">5</span><span style="font-size: 11pt; line-height: 107%; color: black"></span></p>
  </td>
  <td style="width: 48.6pt; padding: 0.75pt 0.75pt 0.75pt 0.75pt; height: 11.35pt" width="65" valign="bottom">
  <p class="MsoNormal" style="vertical-align: bottom"><span style="font-size: 11pt; line-height: 107%; color: black">12</span><span style="font-size: 11pt; line-height: 107%; color: black"></span></p>
  </td>
  <td style="width: 63.65pt; padding: 0.75pt 0.75pt 0.75pt 0.75pt; height: 11.35pt" width="85" valign="bottom">
  <p class="MsoNormal" style="vertical-align: bottom"><span style="font-size: 11pt; line-height: 107%; color: black">8</span><span style="font-size: 11pt; line-height: 107%; color: black"></span></p>
  </td>
 </tr>
 <tr style="height: 11.35pt">
  <td style="width: 61.25pt; background: black; padding: 0.75pt 0.75pt 0.75pt 0.75pt; height: 11.35pt" width="82" valign="bottom">
  <p class="MsoNormal" style="vertical-align: bottom"><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">System ID</span></b><b style=""><span style="font-size: 11pt; line-height: 107%; color: white"></span></b></p>
  </td>
  <td style="width: 53.95pt; padding: 0.75pt 0.75pt 0.75pt 0.75pt; height: 11.35pt" width="72" valign="bottom">
  <p class="MsoNormal" style="vertical-align: bottom"><span style="font-size: 11pt; line-height: 107%; color: black">13</span><span style="font-size: 11pt; line-height: 107%; color: black"></span></p>
  </td>
  <td style="width: 48.6pt; padding: 0.75pt 0.75pt 0.75pt 0.75pt; height: 11.35pt" width="65" valign="bottom">
  <p class="MsoNormal" style="vertical-align: bottom"><span style="font-size: 11pt; line-height: 107%; color: black">15</span><span style="font-size: 11pt; line-height: 107%; color: black"></span></p>
  </td>
  <td style="width: 63.65pt; padding: 0.75pt 0.75pt 0.75pt 0.75pt; height: 11.35pt" width="85" valign="bottom">
  <p class="MsoNormal" style="vertical-align: bottom"><span style="font-size: 11pt; line-height: 107%; color: black">3</span><span style="font-size: 11pt; line-height: 107%; color: black"></span></p>
  </td>
 </tr>
 <tr style="height: 11.35pt">
  <td style="width: 61.25pt; background: black; padding: 0.75pt 0.75pt 0.75pt 0.75pt; height: 11.35pt" width="82" valign="bottom">
  <p class="MsoNormal" style="vertical-align: bottom"><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">File Group</span></b><b style=""><span style="font-size: 11pt; line-height: 107%; color: white"></span></b></p>
  </td>
  <td style="width: 53.95pt; padding: 0.75pt 0.75pt 0.75pt 0.75pt; height: 11.35pt" width="72" valign="bottom">
  <p class="MsoNormal" style="vertical-align: bottom"><span style="font-size: 11pt; line-height: 107%; color: black">16</span><span style="font-size: 11pt; line-height: 107%; color: black"></span></p>
  </td>
  <td style="width: 48.6pt; padding: 0.75pt 0.75pt 0.75pt 0.75pt; height: 11.35pt" width="65" valign="bottom">
  <p class="MsoNormal" style="vertical-align: bottom"><span style="font-size: 11pt; line-height: 107%; color: black">20</span><span style="font-size: 11pt; line-height: 107%; color: black"></span></p>
  </td>
  <td style="width: 63.65pt; padding: 0.75pt 0.75pt 0.75pt 0.75pt; height: 11.35pt" width="85" valign="bottom">
  <p class="MsoNormal" style="vertical-align: bottom"><span style="font-size: 11pt; line-height: 107%; color: black">5</span><span style="font-size: 11pt; line-height: 107%; color: black"></span></p>
  </td>
 </tr>
 <tr style="height: 11.35pt">
  <td style="width: 61.25pt; background: black; padding: 0.75pt 0.75pt 0.75pt 0.75pt; height: 11.35pt" width="82" valign="bottom">
  <p class="MsoNormal" style="vertical-align: bottom"><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">Description</span></b><b style=""><span style="font-size: 11pt; line-height: 107%; color: white"></span></b></p>
  </td>
  <td style="width: 53.95pt; padding: 0.75pt 0.75pt 0.75pt 0.75pt; height: 11.35pt" width="72" valign="bottom">
  <p class="MsoNormal" style="vertical-align: bottom"><span style="font-size: 11pt; line-height: 107%; color: black">21</span><span style="font-size: 11pt; line-height: 107%; color: black"></span></p>
  </td>
  <td style="width: 48.6pt; padding: 0.75pt 0.75pt 0.75pt 0.75pt; height: 11.35pt" width="65" valign="bottom">
  <p class="MsoNormal" style="vertical-align: bottom"><span style="font-size: 11pt; line-height: 107%; color: black">78</span><span style="font-size: 11pt; line-height: 107%; color: black"></span></p>
  </td>
  <td style="width: 63.65pt; padding: 0.75pt 0.75pt 0.75pt 0.75pt; height: 11.35pt" width="85" valign="bottom">
  <p class="MsoNormal" style="vertical-align: bottom"><span style="font-size: 11pt; line-height: 107%; color: black">58</span><span style="font-size: 11pt; line-height: 107%; color: black"></span></p>
  </td>
 </tr>
 <tr style="height: 11.35pt">
  <td style="width: 61.25pt; background: black; padding: 0.75pt 0.75pt 0.75pt 0.75pt; height: 11.35pt" width="82" valign="bottom">
  <p class="MsoNormal" style="vertical-align: bottom"><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">File Name</span></b><b style=""><span style="font-size: 11pt; line-height: 107%; color: white"></span></b></p>
  </td>
  <td style="width: 53.95pt; padding: 0.75pt 0.75pt 0.75pt 0.75pt; height: 11.35pt" width="72" valign="bottom">
  <p class="MsoNormal" style="vertical-align: bottom"><span style="font-size: 11pt; line-height: 107%; color: black">79</span><span style="font-size: 11pt; line-height: 107%; color: black"></span></p>
  </td>
  <td style="width: 48.6pt; padding: 0.75pt 0.75pt 0.75pt 0.75pt; height: 11.35pt" width="65" valign="bottom">
  <p class="MsoNormal" style="vertical-align: bottom"><span style="font-size: 11pt; line-height: 107%; color: black">230</span><span style="font-size: 11pt; line-height: 107%; color: black"></span></p>
  </td>
  <td style="width: 63.65pt; padding: 0.75pt 0.75pt 0.75pt 0.75pt; height: 11.35pt" width="85" valign="bottom">
  <p class="MsoNormal" style="vertical-align: bottom"><span style="font-size: 11pt; line-height: 107%; color: black">152</span><span style="font-size: 11pt; line-height: 107%; color: black"></span></p>
  </td>
 </tr>
 <tr style="height: 11.35pt">
  <td style="width: 61.25pt; background: black; padding: 0.75pt 0.75pt 0.75pt 0.75pt; height: 11.35pt" width="82" valign="bottom">
  <p class="MsoNormal" style="vertical-align: bottom"><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">Filler</span></b><b style=""><span style="font-size: 11pt; line-height: 107%; color: white"></span></b></p>
  </td>
  <td style="width: 53.95pt; padding: 0.75pt 0.75pt 0.75pt 0.75pt; height: 11.35pt" width="72" valign="bottom">
  <p class="MsoNormal" style="vertical-align: bottom"><span style="font-size: 11pt; line-height: 107%; color: black">231</span><span style="font-size: 11pt; line-height: 107%; color: black"></span></p>
  </td>
  <td style="width: 48.6pt; padding: 0.75pt 0.75pt 0.75pt 0.75pt; height: 11.35pt" width="65" valign="bottom">
  <p class="MsoNormal" style="vertical-align: bottom"><span style="font-size: 11pt; line-height: 107%; color: black">259</span><span style="font-size: 11pt; line-height: 107%; color: black"></span></p>
  </td>
  <td style="width: 63.65pt; padding: 0.75pt 0.75pt 0.75pt 0.75pt; height: 11.35pt" width="85" valign="bottom">
  <p class="MsoNormal" style="vertical-align: bottom"><span style="font-size: 11pt; line-height: 107%; color: black">29</span><span style="font-size: 11pt; line-height: 107%; color: black"></span></p>
  </td>
 </tr>
 <tr style="height: 11.35pt">
  <td style="width: 61.25pt; background: black; padding: 0.75pt 0.75pt 0.75pt 0.75pt; height: 11.35pt" width="82" valign="bottom">
  <p class="MsoNormal" style="vertical-align: bottom"><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">File Alias</span></b><b style=""><span style="font-size: 11pt; line-height: 107%; color: white"></span></b></p>
  </td>
  <td style="width: 53.95pt; padding: 0.75pt 0.75pt 0.75pt 0.75pt; height: 11.35pt" width="72" valign="bottom">
  <p class="MsoNormal" style="vertical-align: bottom"><span style="font-size: 11pt; line-height: 107%; color: black">159</span><span style="font-size: 11pt; line-height: 107%; color: black"></span></p>
  </td>
  <td style="width: 48.6pt; padding: 0.75pt 0.75pt 0.75pt 0.75pt; height: 11.35pt" width="65" valign="bottom">
  <p class="MsoNormal" style="vertical-align: bottom"><span style="font-size: 11pt; line-height: 107%; color: black">162</span><span style="font-size: 11pt; line-height: 107%; color: black"></span></p>
  </td>
  <td style="width: 63.65pt; padding: 0.75pt 0.75pt 0.75pt 0.75pt; height: 11.35pt" width="85" valign="bottom">
  <p class="MsoNormal" style="vertical-align: bottom"><span style="font-size: 11pt; line-height: 107%; color: black">4</span><span style="font-size: 11pt; line-height: 107%; color: black"></span></p>
  </td>
 </tr>
 <tr style="height: 11.35pt">
  <td style="width: 61.25pt; background: black; padding: 0.75pt 0.75pt 0.75pt 0.75pt; height: 11.35pt" width="82" valign="bottom">
  <p class="MsoNormal" style="vertical-align: bottom"><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">Filler</span></b><b style=""><span style="font-size: 11pt; line-height: 107%; color: white"></span></b></p>
  </td>
  <td style="width: 53.95pt; padding: 0.75pt 0.75pt 0.75pt 0.75pt; height: 11.35pt" width="72" valign="bottom">
  <p class="MsoNormal" style="vertical-align: bottom"><span style="font-size: 11pt; line-height: 107%; color: black">263</span><span style="font-size: 11pt; line-height: 107%; color: black"></span></p>
  </td>
  <td style="width: 48.6pt; padding: 0.75pt 0.75pt 0.75pt 0.75pt; height: 11.35pt" width="65" valign="bottom">
  <p class="MsoNormal" style="vertical-align: bottom"><span style="font-size: 11pt; line-height: 107%; color: black">266</span><span style="font-size: 11pt; line-height: 107%; color: black"></span></p>
  </td>
  <td style="width: 63.65pt; padding: 0.75pt 0.75pt 0.75pt 0.75pt; height: 11.35pt" width="85" valign="bottom">
  <p class="MsoNormal" style="vertical-align: bottom"><span style="font-size: 11pt; line-height: 107%; color: black">4</span><span style="font-size: 11pt; line-height: 107%; color: black"></span></p>
  </td>
 </tr>
 <tr style="height: 11.35pt">
  <td style="width: 61.25pt; background: black; padding: 0.75pt 0.75pt 0.75pt 0.75pt; height: 11.35pt" width="82" valign="bottom">
  <p class="MsoNormal" style="vertical-align: bottom"><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">CICS Region</span></b><b style=""><span style="font-size: 11pt; line-height: 107%; color: white"></span></b></p>
  </td>
  <td style="width: 53.95pt; padding: 0.75pt 0.75pt 0.75pt 0.75pt; height: 11.35pt" width="72" valign="bottom">
  <p class="MsoNormal" style="vertical-align: bottom"><span style="font-size: 11pt; line-height: 107%; color: black">267</span><span style="font-size: 11pt; line-height: 107%; color: black"></span></p>
  </td>
  <td style="width: 48.6pt; padding: 0.75pt 0.75pt 0.75pt 0.75pt; height: 11.35pt" width="65" valign="bottom">
  <p class="MsoNormal" style="vertical-align: bottom"><span style="font-size: 11pt; line-height: 107%; color: black">270</span><span style="font-size: 11pt; line-height: 107%; color: black"></span></p>
  </td>
  <td style="width: 63.65pt; padding: 0.75pt 0.75pt 0.75pt 0.75pt; height: 11.35pt" width="85" valign="bottom">
  <p class="MsoNormal" style="vertical-align: bottom"><span style="font-size: 11pt; line-height: 107%; color: black">4</span><span style="font-size: 11pt; line-height: 107%; color: black"></span></p>
  </td>
 </tr>
 <tr style="height: 11.35pt">
  <td style="width: 61.25pt; background: black; padding: 0.75pt 0.75pt 0.75pt 0.75pt; height: 11.35pt" width="82" valign="bottom">
  <p class="MsoNormal" style="vertical-align: bottom"><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">File Name2</span></b><b style=""><span style="font-size: 11pt; line-height: 107%; color: white"></span></b></p>
  </td>
  <td style="width: 53.95pt; padding: 0.75pt 0.75pt 0.75pt 0.75pt; height: 11.35pt" width="72" valign="bottom">
  <p class="MsoNormal" style="vertical-align: bottom"><span style="font-size: 11pt; line-height: 107%; color: black">271</span><span style="font-size: 11pt; line-height: 107%; color: black"></span></p>
  </td>
  <td style="width: 48.6pt; padding: 0.75pt 0.75pt 0.75pt 0.75pt; height: 11.35pt" width="65" valign="bottom">
  <p class="MsoNormal" style="vertical-align: bottom"><span style="font-size: 11pt; line-height: 107%; color: black">278</span><span style="font-size: 11pt; line-height: 107%; color: black"></span></p>
  </td>
  <td style="width: 63.65pt; padding: 0.75pt 0.75pt 0.75pt 0.75pt; height: 11.35pt" width="85" valign="bottom">
  <p class="MsoNormal" style="vertical-align: bottom"><span style="font-size: 11pt; line-height: 107%; color: black">8</span><span style="font-size: 11pt; line-height: 107%; color: black"></span></p>
  </td>
 </tr>
 <tr style="height: 11.35pt">
  <td style="width: 61.25pt; background: black; padding: 0.75pt 0.75pt 0.75pt 0.75pt; height: 11.35pt" width="82" valign="bottom">
  <p class="MsoNormal" style="vertical-align: bottom"><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">Filler</span></b><b style=""><span style="font-size: 11pt; line-height: 107%; color: white"></span></b></p>
  </td>
  <td style="width: 53.95pt; padding: 0.75pt 0.75pt 0.75pt 0.75pt; height: 11.35pt" width="72" valign="bottom">
  <p class="MsoNormal" style="vertical-align: bottom"><span style="font-size: 11pt; line-height: 107%; color: black">279</span><span style="font-size: 11pt; line-height: 107%; color: black"></span></p>
  </td>
  <td style="width: 48.6pt; padding: 0.75pt 0.75pt 0.75pt 0.75pt; height: 11.35pt" width="65" valign="bottom">
  <p class="MsoNormal" style="vertical-align: bottom"><span style="font-size: 11pt; line-height: 107%; color: black">1536</span><span style="font-size: 11pt; line-height: 107%; color: black"></span></p>
  </td>
  <td style="width: 63.65pt; padding: 0.75pt 0.75pt 0.75pt 0.75pt; height: 11.35pt" width="85" valign="bottom">
  <p class="MsoNormal" style="vertical-align: bottom"><span style="font-size: 11pt; line-height: 107%; color: black">1258</span><span style="font-size: 11pt; line-height: 107%; color: black"></span></p>
  </td>
 </tr>
</tbody></table>

</div>

<p class="MsoNormal"><span style="">&nbsp;</span></p>

<p class="MsoNormal"><span style="">&nbsp;</span></p>

<p class="MsoHeader"><b><span style="">Mapset
Items</span></b></p>

<div align="center">

<table class="MsoNormalTable" style="border-collapse: collapse" width="312" cellspacing="0" cellpadding="0" border="0">
 <tbody><tr style="height: 14.15pt">
  <td style="width: 71.25pt; background: black; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="95" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><b style=""><span style="font-size: 11pt; line-height: 107%">&nbsp;</span></b></p>
  </td>
  <td style="width: 52.5pt; background: black; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="70" valign="top">
  <p class="MsoNormal"><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">Field Start</span></b><b style=""><span style="font-size: 11pt; line-height: 107%"></span></b></p>
  </td>
  <td style="width: 48pt; background: black; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="64" valign="top">
  <p class="MsoNormal"><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">Field End</span></b><b style=""><span style="font-size: 11pt; line-height: 107%"></span></b></p>
  </td>
  <td style="width: 62.25pt; background: black; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="83" valign="top">
  <p class="MsoNormal"><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">Field Length</span></b><b style=""><span style="font-size: 11pt; line-height: 107%"></span></b></p>
  </td>
 </tr>
 <tr style="height: 14.15pt">
  <td style="width: 71.25pt; background: black; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="95" valign="top">
  <p class="MsoNormal"><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">Type</span></b><b style=""><span style="font-size: 11pt; line-height: 107%"></span></b></p>
  </td>
  <td style="width: 52.5pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="70" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">1</span></p>
  </td>
  <td style="width: 48pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="64" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">4</span></p>
  </td>
  <td style="width: 62.25pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="83" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">4</span></p>
  </td>
 </tr>
 <tr style="height: 14.15pt">
  <td style="width: 71.25pt; background: black; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="95" valign="top">
  <p class="MsoNormal"><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">Mapset Name</span></b></p>
  </td>
  <td style="width: 52.5pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="70" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">5</span></p>
  </td>
  <td style="width: 48pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="64" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">12</span></p>
  </td>
  <td style="width: 62.25pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="83" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">8</span></p>
  </td>
 </tr>
 <tr style="height: 14.15pt">
  <td style="width: 71.25pt; background: black; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="95" valign="top">
  <p class="MsoNormal"><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">System ID</span></b></p>
  </td>
  <td style="width: 52.5pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="70" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">13</span></p>
  </td>
  <td style="width: 48pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="64" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">15</span></p>
  </td>
  <td style="width: 62.25pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="83" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">3</span></p>
  </td>
 </tr>
 <tr style="height: 14.15pt">
  <td style="width: 71.25pt; background: black; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="95" valign="top">
  <p class="MsoNormal"><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">Map Group</span></b></p>
  </td>
  <td style="width: 52.5pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="70" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">16</span></p>
  </td>
  <td style="width: 48pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="64" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">20</span></p>
  </td>
  <td style="width: 62.25pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="83" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">5</span></p>
  </td>
 </tr>
 <tr style="height: 14.15pt">
  <td style="width: 71.25pt; background: black; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="95" valign="top">
  <p class="MsoNormal"><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">Description</span></b></p>
  </td>
  <td style="width: 52.5pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="70" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">21</span></p>
  </td>
  <td style="width: 48pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="64" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">78</span></p>
  </td>
  <td style="width: 62.25pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="83" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">58</span></p>
  </td>
 </tr>
 <tr style="height: 14.15pt">
  <td style="width: 71.25pt; background: black; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="95" valign="top">
  <p class="MsoNormal"><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">Filler</span></b></p>
  </td>
  <td style="width: 52.5pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="70" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">79</span></p>
  </td>
  <td style="width: 48pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="64" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">1536</span></p>
  </td>
  <td style="width: 62.25pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="83" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">1458</span></p>
  </td>
 </tr>
</tbody></table>

</div>

<p class="MsoNormal"><span style="">&nbsp;</span></p>

<p class="MsoHeader" style="page-break-after: avoid"><b><span style="">Program
Items</span></b></p>

<p class="MsoNormal" style="page-break-after: avoid"><span style="">&nbsp;</span></p>

<div align="center">

<table class="MsoNormalTable" style="border-collapse: collapse" width="295" cellspacing="0" cellpadding="0" border="0">
 <tbody><tr style="height: 14.15pt">
  <td style="width: 58.5pt; background: black; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="78" valign="top">
  <p class="MsoNormal" style="text-align: right; page-break-after: avoid" align="right"><b style=""><span style="font-size: 11pt; line-height: 107%">&nbsp;</span></b></p>
  </td>
  <td style="width: 52.5pt; background: black; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="70" valign="top">
  <p class="MsoNormal" style="page-break-after: avoid"><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">Field
  Start</span></b><b style=""><span style="font-size: 11pt; line-height: 107%"></span></b></p>
  </td>
  <td style="width: 48pt; background: black; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="64" valign="top">
  <p class="MsoNormal" style="page-break-after: avoid"><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">Field
  End</span></b><b style=""><span style="font-size: 11pt; line-height: 107%"></span></b></p>
  </td>
  <td style="width: 62.25pt; background: black; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="83" valign="top">
  <p class="MsoNormal" style="page-break-after: avoid"><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">Field
  Length</span></b><b style=""><span style="font-size: 11pt; line-height: 107%"></span></b></p>
  </td>
 </tr>
 <tr style="height: 14.25pt">
  <td style="width: 58.5pt; background: black; padding: 0in 5.4pt 0in 5.4pt; height: 14.25pt" width="78" valign="top">
  <p class="MsoNormal" style="page-break-after: avoid"><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">Type</span></b><b style=""><span style="font-size: 11pt; line-height: 107%"></span></b></p>
  </td>
  <td style="width: 52.5pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.25pt" width="70" valign="top">
  <p class="MsoNormal" style="text-align: right; page-break-after: avoid" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">1</span></p>
  </td>
  <td style="width: 48pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.25pt" width="64" valign="top">
  <p class="MsoNormal" style="text-align: right; page-break-after: avoid" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">4</span></p>
  </td>
  <td style="width: 62.25pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.25pt" width="83" valign="top">
  <p class="MsoNormal" style="text-align: right; page-break-after: avoid" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">4</span></p>
  </td>
 </tr>
 <tr style="height: 14.25pt">
  <td style="width: 58.5pt; background: black; padding: 0in 5.4pt 0in 5.4pt; height: 14.25pt" width="78" valign="top">
  <p class="MsoNormal" style="page-break-after: avoid"><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">Program</span></b></p>
  </td>
  <td style="width: 52.5pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.25pt" width="70" valign="top">
  <p class="MsoNormal" style="text-align: right; page-break-after: avoid" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">5</span></p>
  </td>
  <td style="width: 48pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.25pt" width="64" valign="top">
  <p class="MsoNormal" style="text-align: right; page-break-after: avoid" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">12</span></p>
  </td>
  <td style="width: 62.25pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.25pt" width="83" valign="top">
  <p class="MsoNormal" style="text-align: right; page-break-after: avoid" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">8</span></p>
  </td>
 </tr>
 <tr style="height: 14.25pt">
  <td style="width: 58.5pt; background: black; padding: 0in 5.4pt 0in 5.4pt; height: 14.25pt" width="78" valign="top">
  <p class="MsoNormal" style="page-break-after: avoid"><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">System ID</span></b></p>
  </td>
  <td style="width: 52.5pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.25pt" width="70" valign="top">
  <p class="MsoNormal" style="text-align: right; page-break-after: avoid" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">13</span></p>
  </td>
  <td style="width: 48pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.25pt" width="64" valign="top">
  <p class="MsoNormal" style="text-align: right; page-break-after: avoid" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">15</span></p>
  </td>
  <td style="width: 62.25pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.25pt" width="83" valign="top">
  <p class="MsoNormal" style="text-align: right; page-break-after: avoid" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">3</span></p>
  </td>
 </tr>
 <tr style="height: 14.25pt">
  <td style="width: 58.5pt; background: black; padding: 0in 5.4pt 0in 5.4pt; height: 14.25pt" width="78" valign="top">
  <p class="MsoNormal" style="page-break-after: avoid"><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">Prog Group</span></b></p>
  </td>
  <td style="width: 52.5pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.25pt" width="70" valign="top">
  <p class="MsoNormal" style="text-align: right; page-break-after: avoid" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">16</span></p>
  </td>
  <td style="width: 48pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.25pt" width="64" valign="top">
  <p class="MsoNormal" style="text-align: right; page-break-after: avoid" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">20</span></p>
  </td>
  <td style="width: 62.25pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.25pt" width="83" valign="top">
  <p class="MsoNormal" style="text-align: right; page-break-after: avoid" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">5</span></p>
  </td>
 </tr>
 <tr style="height: 14.25pt">
  <td style="width: 58.5pt; background: black; padding: 0in 5.4pt 0in 5.4pt; height: 14.25pt" width="78" valign="top">
  <p class="MsoNormal" style="page-break-after: avoid"><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">Description</span></b></p>
  </td>
  <td style="width: 52.5pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.25pt" width="70" valign="top">
  <p class="MsoNormal" style="text-align: right; page-break-after: avoid" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">21</span></p>
  </td>
  <td style="width: 48pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.25pt" width="64" valign="top">
  <p class="MsoNormal" style="text-align: right; page-break-after: avoid" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">78</span></p>
  </td>
  <td style="width: 62.25pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.25pt" width="83" valign="top">
  <p class="MsoNormal" style="text-align: right; page-break-after: avoid" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">58</span></p>
  </td>
 </tr>
 <tr style="height: 14.25pt">
  <td style="width: 58.5pt; background: black; padding: 0in 5.4pt 0in 5.4pt; height: 14.25pt" width="78" valign="top">
  <p class="MsoNormal" style="page-break-after: avoid"><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">Language</span></b></p>
  </td>
  <td style="width: 52.5pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.25pt" width="70" valign="top">
  <p class="MsoNormal" style="text-align: right; page-break-after: avoid" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">79</span></p>
  </td>
  <td style="width: 48pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.25pt" width="64" valign="top">
  <p class="MsoNormal" style="text-align: right; page-break-after: avoid" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">86</span></p>
  </td>
  <td style="width: 62.25pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.25pt" width="83" valign="top">
  <p class="MsoNormal" style="text-align: right; page-break-after: avoid" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">8</span></p>
  </td>
 </tr>
 <tr style="height: 14.25pt">
  <td style="width: 58.5pt; background: black; padding: 0in 5.4pt 0in 5.4pt; height: 14.25pt" width="78" valign="top">
  <p class="MsoNormal" style="page-break-after: avoid"><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">Filler</span></b></p>
  </td>
  <td style="width: 52.5pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.25pt" width="70" valign="top">
  <p class="MsoNormal" style="text-align: right; page-break-after: avoid" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">87</span></p>
  </td>
  <td style="width: 48pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.25pt" width="64" valign="top">
  <p class="MsoNormal" style="text-align: right; page-break-after: avoid" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">1536</span></p>
  </td>
  <td style="width: 62.25pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.25pt" width="83" valign="top">
  <p class="MsoNormal" style="text-align: right; page-break-after: avoid" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">1450</span></p>
  </td>
 </tr>
</tbody></table>

</div>

<p class="MsoNormal" style="page-break-after: avoid"><span style="">&nbsp;</span></p>

<p class="MsoHeader"><b><span style="">CICS
Queue Items</span></b></p>

<div align="center">

<table class="MsoNormalTable" style="border-collapse: collapse" width="309" cellspacing="0" cellpadding="0" border="0">
 <tbody><tr style="height: 14.15pt">
  <td style="width: 69pt; background: black; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="92" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><b style=""><span style="font-size: 11pt; line-height: 107%">&nbsp;</span></b></p>
  </td>
  <td style="width: 52.5pt; background: black; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="70" valign="top">
  <p class="MsoNormal"><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">Field Start</span></b><b style=""><span style="font-size: 11pt; line-height: 107%"></span></b></p>
  </td>
  <td style="width: 48pt; background: black; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="64" valign="top">
  <p class="MsoNormal"><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">Field End</span></b><b style=""><span style="font-size: 11pt; line-height: 107%"></span></b></p>
  </td>
  <td style="width: 62.25pt; background: black; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="83" valign="top">
  <p class="MsoNormal"><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">Field Length</span></b><b style=""><span style="font-size: 11pt; line-height: 107%"></span></b></p>
  </td>
 </tr>
 <tr style="height: 14.15pt">
  <td style="width: 69pt; background: black; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="92" valign="top">
  <p class="MsoNormal"><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">Type</span></b><b style=""><span style="font-size: 11pt; line-height: 107%"></span></b></p>
  </td>
  <td style="width: 52.5pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="70" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">1</span></p>
  </td>
  <td style="width: 48pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="64" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">4</span></p>
  </td>
  <td style="width: 62.25pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="83" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">4</span></p>
  </td>
 </tr>
 <tr style="height: 14.15pt">
  <td style="width: 69pt; background: black; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="92" valign="top">
  <p class="MsoNormal"><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">Queue Name</span></b></p>
  </td>
  <td style="width: 52.5pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="70" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">5</span></p>
  </td>
  <td style="width: 48pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="64" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">12</span></p>
  </td>
  <td style="width: 62.25pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="83" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">8</span></p>
  </td>
 </tr>
 <tr style="height: 14.15pt">
  <td style="width: 69pt; background: black; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="92" valign="top">
  <p class="MsoNormal"><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">System ID</span></b></p>
  </td>
  <td style="width: 52.5pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="70" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">13</span></p>
  </td>
  <td style="width: 48pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="64" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">15</span></p>
  </td>
  <td style="width: 62.25pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="83" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">3</span></p>
  </td>
 </tr>
 <tr style="height: 14.15pt">
  <td style="width: 69pt; background: black; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="92" valign="top">
  <p class="MsoNormal"><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">Queue Group</span></b></p>
  </td>
  <td style="width: 52.5pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="70" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">16</span></p>
  </td>
  <td style="width: 48pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="64" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">20</span></p>
  </td>
  <td style="width: 62.25pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="83" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">5</span></p>
  </td>
 </tr>
 <tr style="height: 14.15pt">
  <td style="width: 69pt; background: black; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="92" valign="top">
  <p class="MsoNormal"><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">Description</span></b></p>
  </td>
  <td style="width: 52.5pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="70" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">21</span></p>
  </td>
  <td style="width: 48pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="64" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">78</span></p>
  </td>
  <td style="width: 62.25pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="83" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">58</span></p>
  </td>
 </tr>
 <tr style="height: 14.15pt">
  <td style="width: 69pt; background: black; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="92" valign="top">
  <p class="MsoNormal"><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">Queue Type</span></b></p>
  </td>
  <td style="width: 52.5pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="70" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">79</span></p>
  </td>
  <td style="width: 48pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="64" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">86</span></p>
  </td>
  <td style="width: 62.25pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="83" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">8</span></p>
  </td>
 </tr>
 <tr style="height: 14.15pt">
  <td style="width: 69pt; background: black; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="92" valign="top">
  <p class="MsoNormal"><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">Filler</span></b></p>
  </td>
  <td style="width: 52.5pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="70" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">87</span></p>
  </td>
  <td style="width: 48pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="64" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">89</span></p>
  </td>
  <td style="width: 62.25pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="83" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">3</span></p>
  </td>
 </tr>
 <tr style="height: 14.15pt">
  <td style="width: 69pt; background: black; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="92" valign="top">
  <p class="MsoNormal"><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">Log File</span></b></p>
  </td>
  <td style="width: 52.5pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="70" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">90</span></p>
  </td>
  <td style="width: 48pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="64" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">141</span></p>
  </td>
  <td style="width: 62.25pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="83" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">52</span></p>
  </td>
 </tr>
 <tr style="height: 14.15pt">
  <td style="width: 69pt; background: black; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="92" valign="top">
  <p class="MsoNormal"><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">Log File Def</span></b></p>
  </td>
  <td style="width: 52.5pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="70" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">141</span></p>
  </td>
  <td style="width: 48pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="64" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">199</span></p>
  </td>
  <td style="width: 62.25pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="83" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">59</span></p>
  </td>
 </tr>
 <tr style="height: 14.15pt">
  <td style="width: 69pt; background: black; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="92" valign="top">
  <p class="MsoNormal"><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">Filler</span></b></p>
  </td>
  <td style="width: 52.5pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="70" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">200</span></p>
  </td>
  <td style="width: 48pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="64" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">219</span></p>
  </td>
  <td style="width: 62.25pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="83" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">20</span></p>
  </td>
 </tr>
 <tr style="height: 14.15pt">
  <td style="width: 69pt; background: black; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="92" valign="top">
  <p class="MsoNormal"><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">Tran to Start</span></b></p>
  </td>
  <td style="width: 52.5pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="70" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">220</span></p>
  </td>
  <td style="width: 48pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="64" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">223</span></p>
  </td>
  <td style="width: 62.25pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="83" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">4</span></p>
  </td>
 </tr>
 <tr style="height: 14.15pt">
  <td style="width: 69pt; background: black; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="92" valign="top">
  <p class="MsoNormal"><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">Filler</span></b></p>
  </td>
  <td style="width: 52.5pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="70" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">224</span></p>
  </td>
  <td style="width: 48pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="64" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">249</span></p>
  </td>
  <td style="width: 62.25pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="83" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">26</span></p>
  </td>
 </tr>
 <tr style="height: 14.15pt">
  <td style="width: 69pt; background: black; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="92" valign="top">
  <p class="MsoNormal"><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">Queue Name</span></b></p>
  </td>
  <td style="width: 52.5pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="70" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">250</span></p>
  </td>
  <td style="width: 48pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="64" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">253</span></p>
  </td>
  <td style="width: 62.25pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="83" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">4</span></p>
  </td>
 </tr>
 <tr style="height: 14.15pt">
  <td style="width: 69pt; background: black; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="92" valign="top">
  <p class="MsoNormal"><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">CICS Region</span></b></p>
  </td>
  <td style="width: 52.5pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="70" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">254</span></p>
  </td>
  <td style="width: 48pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="64" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">257</span></p>
  </td>
  <td style="width: 62.25pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="83" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">4</span></p>
  </td>
 </tr>
 <tr style="height: 14.15pt">
  <td style="width: 69pt; background: black; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="92" valign="top">
  <p class="MsoNormal"><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">Filler</span></b></p>
  </td>
  <td style="width: 52.5pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="70" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">258</span></p>
  </td>
  <td style="width: 48pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="64" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">1536</span></p>
  </td>
  <td style="width: 62.25pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="83" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">1279</span></p>
  </td>
 </tr>
</tbody></table>

</div>

<p class="MsoNormal"><span style="">&nbsp;</span></p>

<p class="MsoHeader"><b><span style="">CICS Transaction
Items</span></b></p>

<div align="center">

<table class="MsoNormalTable" style="border-collapse: collapse" width="309" cellspacing="0" cellpadding="0" border="0">
 <tbody><tr style="page-break-inside: avoid; height: 14.15pt">
  <td style="width: 69pt; background: black; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="92" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><b style=""><span style="font-size: 11pt; line-height: 107%">&nbsp;</span></b></p>
  </td>
  <td style="width: 52.5pt; background: black; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="70" valign="top">
  <p class="MsoNormal" style=""><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">Field Start</span></b><b style=""><span style="font-size: 11pt; line-height: 107%"></span></b></p>
  </td>
  <td style="width: 48pt; background: black; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="64" valign="top">
  <p class="MsoNormal" style=""><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">Field End</span></b><b style=""><span style="font-size: 11pt; line-height: 107%"></span></b></p>
  </td>
  <td style="width: 62.25pt; background: black; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="83" valign="top">
  <p class="MsoNormal" style=""><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">Field Length</span></b><b style=""><span style="font-size: 11pt; line-height: 107%"></span></b></p>
  </td>
 </tr>
 <tr style="page-break-inside: avoid; height: 14.15pt">
  <td style="width: 69pt; background: black; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="92" valign="top">
  <p class="MsoNormal" style=""><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">Type</span></b><b style=""><span style="font-size: 11pt; line-height: 107%"></span></b></p>
  </td>
  <td style="width: 52.5pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="70" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">1</span></p>
  </td>
  <td style="width: 48pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="64" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">4</span></p>
  </td>
  <td style="width: 62.25pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="83" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">4</span></p>
  </td>
 </tr>
 <tr style="page-break-inside: avoid; height: 14.15pt">
  <td style="width: 69pt; background: black; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="92" valign="top">
  <p class="MsoNormal" style=""><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">Tran ID1</span></b></p>
  </td>
  <td style="width: 52.5pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="70" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">5</span></p>
  </td>
  <td style="width: 48pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="64" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">12</span></p>
  </td>
  <td style="width: 62.25pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="83" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">8</span></p>
  </td>
 </tr>
 <tr style="page-break-inside: avoid; height: 14.15pt">
  <td style="width: 69pt; background: black; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="92" valign="top">
  <p class="MsoNormal" style=""><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">System ID</span></b></p>
  </td>
  <td style="width: 52.5pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="70" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">13</span></p>
  </td>
  <td style="width: 48pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="64" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">15</span></p>
  </td>
  <td style="width: 62.25pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="83" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">3</span></p>
  </td>
 </tr>
 <tr style="page-break-inside: avoid; height: 14.15pt">
  <td style="width: 69pt; background: black; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="92" valign="top">
  <p class="MsoNormal" style=""><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">Tran Group</span></b></p>
  </td>
  <td style="width: 52.5pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="70" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">16</span></p>
  </td>
  <td style="width: 48pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="64" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">20</span></p>
  </td>
  <td style="width: 62.25pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="83" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">5</span></p>
  </td>
 </tr>
 <tr style="page-break-inside: avoid; height: 14.15pt">
  <td style="width: 69pt; background: black; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="92" valign="top">
  <p class="MsoNormal" style=""><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">Description</span></b></p>
  </td>
  <td style="width: 52.5pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="70" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">21</span></p>
  </td>
  <td style="width: 48pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="64" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">78</span></p>
  </td>
  <td style="width: 62.25pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="83" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">58</span></p>
  </td>
 </tr>
 <tr style="page-break-inside: avoid; height: 14.15pt">
  <td style="width: 69pt; background: black; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="92" valign="top">
  <p class="MsoNormal" style=""><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">Tran Program</span></b></p>
  </td>
  <td style="width: 52.5pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="70" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">79</span></p>
  </td>
  <td style="width: 48pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="64" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">86</span></p>
  </td>
  <td style="width: 62.25pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="83" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">8</span></p>
  </td>
 </tr>
 <tr style="page-break-inside: avoid; height: 14.15pt">
  <td style="width: 69pt; background: black; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="92" valign="top">
  <p class="MsoNormal" style=""><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">Filler</span></b></p>
  </td>
  <td style="width: 52.5pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="70" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">87</span></p>
  </td>
  <td style="width: 48pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="64" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">159</span></p>
  </td>
  <td style="width: 62.25pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="83" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">73</span></p>
  </td>
 </tr>
 <tr style="page-break-inside: avoid; height: 14.15pt">
  <td style="width: 69pt; background: black; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="92" valign="top">
  <p class="MsoNormal" style=""><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">CICS Region</span></b></p>
  </td>
  <td style="width: 52.5pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="70" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">160</span></p>
  </td>
  <td style="width: 48pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="64" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">163</span></p>
  </td>
  <td style="width: 62.25pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="83" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">4</span></p>
  </td>
 </tr>
 <tr style="page-break-inside: avoid; height: 14.15pt">
  <td style="width: 69pt; background: black; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="92" valign="top">
  <p class="MsoNormal" style=""><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">Tran ID 2</span></b></p>
  </td>
  <td style="width: 52.5pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="70" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">164</span></p>
  </td>
  <td style="width: 48pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="64" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">171</span></p>
  </td>
  <td style="width: 62.25pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="83" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">8</span></p>
  </td>
 </tr>
 <tr style="page-break-inside: avoid; height: 14.15pt">
  <td style="width: 69pt; background: black; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="92" valign="top">
  <p class="MsoNormal" style=""><b style=""><span style="font-size: 11pt; line-height: 107%; color: white">Filler</span></b></p>
  </td>
  <td style="width: 52.5pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="70" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">172</span></p>
  </td>
  <td style="width: 48pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="64" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">1536</span></p>
  </td>
  <td style="width: 62.25pt; padding: 0in 5.4pt 0in 5.4pt; height: 14.15pt" width="83" valign="top">
  <p class="MsoNormal" style="text-align: right" align="right"><span style="font-size: 11pt; line-height: 107%; color: black">1365</span></p>
  </td>
 </tr>
</tbody></table>
</div>
</div>
</div>
</template>

<script>
export default {
    name: 'MainframeInstructions',
}
</script>


// WEBPACK FOOTER //
// src/components/customwidgets/MainframeInstructions.vue